
import { mapState, mapMutations, mapGetters, mapActions } from "vuex"
export default {
  name: "NavBar",
  data: () => ({
    showMobileNav: false,
    isSearching: false,
    imageUrl: process.env.IMAGE_URL,
  }),
  computed: {
    ...mapState([
      "deliveryFilter",
      "cart",
      "isBiz",
      "showSearch",
      "showCart",
      "showServices",
      "showMenus",
      "order",
    ]),
    ...mapGetters(["navItems", "cartItemCount"]),
    correctRoute() {
      return this.currentPage === "search"
    },
    currentPage() {
      return this.$route.name
    },
    showCount() {
      return this.cartItemCount > 0
    },
  },
  watch: {
    $route(to) {
      this.showMobileNav = false
      this.isSearching = false
      this.setShowServices(false)
    },
  },
  methods: {
    ...mapActions(["deepSearch"]),
    ...mapMutations({
      setCartStatus: "SET_CART_STATUS",
      setShowServices: "SET_SHOW_SERVICES",
      setShowMenus: "SET_SHOW_MENUS",
    }),
    toggleSearch(val) {
      this.isSearching = val
      this.showMobileNav = false
      this.$emit("returnSearch", val)
    },
    toggleMobileNav(val) {
      this.showMobileNav = val
      this.isSearching = false
      this.returnCartClick(false)
    },
    returnCartClick(val) {
      this.$emit("returnCartClick", val)
    },
  },
}
